export const styles = (theme) => ({
  checksTableContainer: {
    "max-height": 400,
    padding: 15
  },
  headerStyle: {
    padding: "0px",
    zIndex: "0",
    fontSize: "12px",
    backgroundColor: "rgb(112, 112, 113)",
    color: "white",
  },
  checkTablePagination: {
    margin: 20,
    float: "right",
    opacity: 0.5
  },
  checkedBox: {
      '&&:hover': {
        backgroundColor: 'transparent',
      },
  },
  actionIcons: {
    padding: 8,
    boxShadow: "none",
    '&&:hover': {
      backgroundColor: 'transparent',
    },
  }
});
